module.exports = __webpack_public_path__ + "static/scc-title-e9c7e9a7fa318eb4298229f2c39a36c4.png";